export const HIT_LIST_JOBDESC = 'HIT_LIST_JOBDESC';
export const GET_LIST_JOBDESC = 'GET_LIST_JOBDESC';
export const GET_LIST_JOBDESC_LIMIT = 'GET_LIST_JOBDESC_LIMIT';

export const HIT_LIST_VERSIONID = 'HIT_LIST_VERSIONID';
export const GET_LIST_VERSIONID = 'GET_LIST_VERSIONID';

export const HIT_DETAIL_JOBDESC = 'HIT_DETAIL_JOBDESC';
export const GET_DETAIL_JOBDESC = 'GET_DETAIL_JOBDESC';
export const HIT_HR_APPROVAL = 'HIT_HR_APPROVAL';

export const HIT_DETAIL_JOBDESC_V2 = 'HIT_DETAIL_JOBDESC_V2';
export const GET_DETAIL_JOBDESC_V2 = 'GET_DETAIL_JOBDESC_V2';

export const HIT_ORG_STRUCTURE_JOBDESC = 'HIT_ORG_STRUCTURE_JOBDESC';
export const GET_ORG_STRUCTURE_JOBDESC = 'GET_ORG_STRUCTURE_JOBDESC';

export const HIT_MAINRESPO_JOBDESC = 'HIT_MAINRESPO_JOBDESC';
export const GET_MAINRESPO_JOBDESC = 'GET_MAINRESPO_JOBDESC';

export const HIT_KPI_JOBDESC = 'HIT_KPI_JOBDESC';
export const GET_KPI_JOBDESC = 'GET_KPI_JOBDESC';

export const HIT_AUTHORITY_JOBDESC = 'HIT_AUTHORITY_JOBDESC';
export const GET_AUTHORITY_JOBDESC = 'GET_AUTHORITY_JOBDESC';

export const HIT_WORK_RELATION_JOBDESC = 'HIT_WORK_RELATION_JOBDESC';
export const GET_WORK_RELATION_JOBDESC = 'GET_WORK_RELATION_JOBDESC';
